import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    bookingWindow: null,
    bookingWindows: [],
    bookingLoad: false,
    master: null,
    timeBtnClicked: false,
    booking: null,
    bookingStatuses: [],
    bookings: [],
    bookingsFilters: [],
    newBookings: [],
    currentNewBooking: {},
    susseeded: false,
    newUserModal: false,
    lastBookingID: null,
    bookingPaymentHistory: [],
    bookingHistory: [],
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
